import axios from "axios";

let affiliateSvc = process.env.VUE_APP_COMPANY_API_URL;
let companyRoot = process.env.VUE_APP_COMPANY_USER_ROOT;

axios.defaults.headers.common["api_key"] =
	process.env.VUE_APP_CARD_USER_API_KEY;

const supportAxiosinstance = axios.create({
	baseURL: affiliateSvc,
});

export default {
	beneficiariesService: {
		searchBeneficiaries(beneficiariesFilter, token) {
			return supportAxiosinstance.get(
				companyRoot +
				"/v1/users/search" + beneficiariesFilter,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
		getValorisActivityReport(reportParams, token) {
			return supportAxiosinstance.get(
				companyRoot + "/v1/rlc/valoris/activities_report" + reportParams,
				{
					responseType: "blob",
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
		getBeneficiaryDetails(beneficiaryId, token) {
			return supportAxiosinstance.get(
				companyRoot +
				"/v1/plus/users/" + beneficiaryId,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
		getBeneficiaryDetailsCore(holderId, token, firstView = false) {
			return supportAxiosinstance.get(
				companyRoot +
				"/v1/rlc/beneficiaries/" + holderId,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
                    params: firstView ? { first_view: true } : {},
				}
			);
		},
		getBeneficiaryObservations(holderId, token) {
			return supportAxiosinstance.get(
				companyRoot +
				"/v1/rlc/beneficiaries/" + holderId +
				"/observations",
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
		createBeneficiaryObservations(holderId, observationsData, token) {
			return supportAxiosinstance.post(
				companyRoot +
				"/v1/rlc/beneficiaries/" + holderId +
				"/observations",
				observationsData,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
		updateBeneficiaryObservations(holderId, observationsData, token) {
			return supportAxiosinstance.put(
				companyRoot +
				"/v1/rlc/beneficiaries/" + holderId +
				"/observations",
				observationsData,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
		cardsAction(cardActionOrder, accountId, cardId, token, user) {
			let config = {};
			if (user !== null) {
				config = {
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
						"X-Up-User": user,
					},
				};
			} else {
				config = {
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				};
			}
			return supportAxiosinstance.post(
				companyRoot +
				"/v1/rlc/accounts/" + accountId +
				"/cards/" + cardId +
				"/cards_action",
				cardActionOrder,
				config
			);
		},
		deleteMobileAccount(beneficiaryId, token) {
			return supportAxiosinstance.delete(
				companyRoot +
				"/v1/plus/users/" +
				beneficiaryId,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
		updateMobileAccount(beneficiaryId, mobileData, token) {
			return supportAxiosinstance.put(
				companyRoot +
				"/v1/plus/users/" +
				beneficiaryId,
				mobileData,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
	},
};
